import { render, staticRenderFns } from "./DsMain.vue?vue&type=template&id=042ffed0&scoped=true&"
import script from "./DsMain.vue?vue&type=script&lang=js&"
export * from "./DsMain.vue?vue&type=script&lang=js&"
import style0 from "./DsMain.vue?vue&type=style&index=0&id=042ffed0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "042ffed0",
  null
  
)

export default component.exports